export default class BlobType {
    constructor({ path, blob, image }) {
        this.type = "blob";
        this.path = path;
        this.blob = blob;
        this.image = image;
    }
    toJSON() {
        return {
            type: this.type,
            path: this.path,
        };
    }
}
